import form from "./form";

const {
  formField: { role }
} = form;

const initialValues = {
  [role.name]: ""
};

export default initialValues;
